import type { TOC } from '@ember/component/template-only';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

type ActivitySummaryData = {
  onViewAll: () => void;
  text: string;
};

interface SettingsActivityTdActivitySummarySignature {
  Args: {
    cellData: ActivitySummaryData | string;
  };
}

const isActivitySummaryData = (
  data: ActivitySummaryData | string,
): data is ActivitySummaryData => {
  return data !== null && typeof data === 'object' && 'onViewAll' in data;
};

// The icon is the only way to see the full change list — no expand row or
// inline preview for batched changes.
const TdActivitySummary = <template>
  {{#if (isActivitySummaryData @cellData)}}
    <div class="flex items-center gap-100">
      <span data-test-id="activity-summary-text">{{@cellData.text}}</span>
      <PrismButton
        @buttonType="ghost"
        @icon="expand"
        @onClick={{@cellData.onViewAll}}
        @size="small"
        aria-label={{t "settings.activity_history.expanded.view_all_changes"}}
        data-test-id="view-all-mapping-changes"
      />
    </div>
  {{else}}
    {{@cellData}}
  {{/if}}
</template> satisfies TOC<SettingsActivityTdActivitySummarySignature>;

export default TdActivitySummary;
